const IMAGE_MAX_WIDTH = 1600;
const JPEG_QUALITY = 0.88;

/** Embed a picked file as a data URL (resized) so catalog works without PHP upload. */
export async function fileToCatalogImageDataUrl(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > IMAGE_MAX_WIDTH) {
        height = Math.round((height * IMAGE_MAX_WIDTH) / width);
        width = IMAGE_MAX_WIDTH;
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Could not process image in this browser.'));
        return;
      }
      try {
        ctx.drawImage(img, 0, 0, width, height);
      } catch (drawErr) {
        URL.revokeObjectURL(url);
        reject(
          new Error(
            'Could not process this image in the browser (try JPG or PNG, or use “Upload to site” instead of embed).'
          )
        );
        return;
      }
      const usePng = file.type === 'image/png' || file.type === 'image/gif';
      const dataUrl = usePng ? canvas.toDataURL('image/png') : canvas.toDataURL('image/jpeg', JPEG_QUALITY);
      resolve(dataUrl);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Could not read this image file.'));
    };
    img.src = url;
  });
}
